import { useQuery } from 'react-query'
import { apiAuthClient } from '@app/services/apiAuthClient'
import { endpoints } from '@app/api/config'
import {
  ApiBillingPaymentStatus,
  ApiErrorResponse,
  ApiResponseBillingPaymentStatus,
} from 'BackendApi'
import { getRandomExampleHeader } from '@app/api/utils/mock'

const fetchBillingPaymentStatus = async (): Promise<
  ApiBillingPaymentStatus | undefined
> => {
  const apiResponse = await apiAuthClient.get<ApiResponseBillingPaymentStatus>(
    endpoints.billingPaymentStatus,
    {
      headers: {
        /* ...getRandomExampleHeader(['empty']), */
        /* ...getRandomExampleHeader(['example-1']), */
        ...getRandomExampleHeader(['no-company-name']),
      },
    }
  )
  // data normalization
  const billingData = apiResponse.data.data
  if (billingData) {
    return {
      ...billingData, // preserve any other fields
      amountDue: billingData.amountDue,
      isUnpaid: billingData.isUnpaid,
      hasActiveSubscription: billingData.hasActiveSubscription,
    }
  }
  return billingData
}

export const useGetBillingPaymentStatus = () =>
  useQuery<ApiBillingPaymentStatus | undefined, ApiErrorResponse>(
    ['billingPaymentStatus'],
    fetchBillingPaymentStatus
  )

